import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import Option from '../../Views/OptionWrapper/form/options'
import {TablePermissionWrapper} from './component/table/permissionByOption'
import {useCentral} from '../../../../../hooks/useCentral'
import {TabCentralModel} from '../../../../../models'
import ButtonClose from '../../../../../components/UI/Button/IconButton'
const OptionTab = () => {
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useCentral()

  const handleBack = () => {
    const obj: TabCentralModel = {
      ...currentTabItem,
      showPanel: false,
    }
    // reset()
    changeCurrentTabItem(obj)
  }
  let isDisabled = currentTabItem.idToEdit ? true : false
  return (
    <div className='sdx_content_tab_panel'>
      {isDisabled && <ButtonClose onClick={handleBack} color='#283897' />}

      <Tabs className={'sdx_sub_react_tab_panel '}>
        <TabList className={'sdx_sub_tab_panel p-0'}>
          <Tab className={'sdx_sub_tab_panel_option'}>Actualizar Registro</Tab>
          {isAllowed('PERMISO/ACCESO') && (
            <Tab className={'sdx_sub_tab_panel_option'}>Permisos</Tab>
          )}
        </TabList>
        <TabPanel>
          <Option />
        </TabPanel>
        {isAllowed('PERMISO/ACCESO') && (
          <TabPanel>
            <TablePermissionWrapper />
          </TabPanel>
        )}
      </Tabs>
    </div>
  )
}

export default OptionTab
